module.exports = __webpack_public_path__ + "img/PL08848.92efc88e.png";